export const KEY_ADDRS = {
  CLAIMS_ESCROW: '0x501ACe14202038efA12cD6E4C872D58bB3985e5b',
  CPFARM: '0x501acE321eaF45c42CE37c000aE2e69204c46aAE',
  FARM_CONTROLLER: '0x501aCEDD1a697654d5F53514FF09eDECD3ca6D95',
  FARM_REWARDS: '0x501acEA5a5B21f863215385C1EDaA46eeB562328',
  POLICY_MANAGER: '0x501ace0Bf36573072EA2Cec5Ba44a030F0a2504a',
  RISK_MANAGER: '0x501aCE15950AB3ad217415a960010F9e1CD06E76',
  SOLACE: '0x501acE9c35E60f03A2af4d484f49F9B1EFde9f40',
  XSOLACE_V1: '0x501AcE5aC3Af20F49D53242B6D208f3B91cfc411',
  XSOLACE: '0x501ACe802447B1Ed4Aae36EA830BFBde19afbbF9',
  XSLOCKER: '0x501Ace47c5b0C2099C4464f681c3fa2ECD3146C1',
  STAKING_REWARDS: '0x501ace3D42f9c8723B108D4fBE29989060a91411',
  XSOLACE_MIGRATOR: '0x501aCe6Ce61D1fFecdade5BB04539809Bc301FeE',
  VAULT: '0x501AcEe83a6f269B77c167c6701843D454E2EFA0',
  BOND_DEPO: '0x501ACe81445C57fC438B358F861d3774199cE13c',
}

export const PRODUCT_ADDRS = {
  COMPOUND_PRODUCT: '0x501ACEe4DE210176230Be23d2C681DdB7f59B4EF',
  LIQUITY_PRODUCT: '0x501AcEb7A3585C9F30d91AC3919233e3a54071e0',
  LIQUITY_TROVE_MANAGER: '0x04d630Bff6dea193Fd644dEcfC460db249854a02',
  WAAVE_PRODUCT: '0x501ACe8F1E6Fd2bc2c85101e4664726921Fd4a09',
}

export const TELLER_ADDRS = {
  DAI_TELLER: '0x501AcE5FEe0337e13A442Cb5e15728EE0e8b3F29',
  SOLACE_DAI_SLP_TELLER: '0x9d892A6E9C7d9122be1730E723D4928E985c7be5',
  ETH_TELLER: '0x501ace68E20c29629E690D86E54E79719e2Fc5e8',
  SOLACE_ETH_SLP_TELLER: '0x10AB5087e139Dc531947E0f5b2A8D2F85DA26E77',
  USDC_TELLER: '0x501aCE044AE4E11183026659EE3B0E3b0Df04d7F',
  USDT_TELLER: '0x501acE6061D6176Da12FCBa36Bc85B2fc3FFd5e3',
  SOLACE_USDC_SLP_TELLER: '0x501acEb253483BD58773365334DEf095304CddAE',
  SCP_TELLER: '0x501aCE163FfaCDa6584D75b274eD23155BFf4812',
  WBTC_TELLER: '0x501aCE2f3b5B8f645E67556Df77ac4c3081D84C7',
}

export const TOKEN_ADDRS = {
  WA_REGISTRY: '0x670Fc618C48964F806Cd655600541807ed83a9C5',
  WA_WETH: '0x4e1A6cE8EdEd8c9C74CbF797c6aA0Fbc12D89F71',
  DAI: '0x5592EC0cfb4dbc12D3aB100b257153436a1f0FEa',
  WA_DAI: '0x51758E33047b1199439212cBAf3ecd1C04165bF0',
  BAT: '0xbF7A7169562078c96f0eC1A8aFD6aE50f12e5A99',
  WA_BAT: '0x1E3713729Ab4F2570B823d9c5572B9Cc2E5753Df',
}
